import React, { useState } from 'react'
import styles from './index.module.css'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'

const TrustedPartnerCarousel = ({ partnerdata,isMobile }) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 5,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
      slidesToSlide: 1,
    },
  }

  const CustomLeftArrow = ({ onClick }) => (
    <button
      className={`${styles.navButton} ${styles.prevButton}`}
      aria-label="Previous slide"
      onClick={onClick}
    >
      <img src="images/backword_icon.svg" alt="Previous" />
    </button>
  )

  const CustomRightArrow = ({ onClick }) => (
    <button
      className={`${styles.navButton} ${styles.nextButton}`}
      aria-label="Next slide"
      onClick={onClick}
    >
      <img src="images/forwardIcon.svg" alt="Next" />
    </button>
  )

  const handleImageError = (e) => {
    e.target.onerror = null
    e.target.src = 'images/noimgfound.svg' // Fallback image
  }

  return (
    <div id="Tour Masters" className={styles.container}>
      <div className={styles.container_main}>
        <Carousel
          responsive={responsive}
          infinite={false}
          showDots={false}
          autoPlay={false}
          containerClass={styles.vms_carousel_container}
          itemClass={styles.vms_carousel_item}
          customLeftArrow={!isMobile ? <CustomLeftArrow /> : null}
          customRightArrow={!isMobile ? <CustomRightArrow /> : null}
          beforeChange={(next, state) => setCurrentIndex(next)}
        >
          {partnerdata?.length > 0 &&
            partnerdata.map((tourMaster) => {
              return (
              <div key={tourMaster._id} className={styles.profiles_container} onClick={() => window.open(`/holiday/search?searchby=&type=&category=&city=&month=&client=&vc=${tourMaster?.vender_code}&vn=${tourMaster?.name}`, '_self')}>
                <div className={styles.profiles_wrapper}>
                  <div className={styles.profiles_grid}>
                    <img
                      src={`${tourMaster?.logo ? `/shared/api/media/${tourMaster?.logo}` : 'images/noimgfound.svg'}`}
                      alt="logo"
                      className={styles.profile_image}
                      onError={handleImageError}
                    />
                  </div>
                </div>
              </div>
            )})}
        </Carousel>
      </div>
    </div>
  )
}

export default TrustedPartnerCarousel